import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 1H4V23H14.7964C12.5643 22.0463 11 19.8308 11 17.25C11 17.1663 11.0016 17.0829 11.0049 17H6V3H18V11.0445C18.7101 11.1295 19.3836 11.3334 20 11.6359V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 17.25C22 18.1992 21.7216 19.0834 21.2419 19.8254L22.9142 21.5017L21.4983 22.9142L19.8282 21.2401C19.0857 21.7209 18.2004 22 17.25 22C14.6266 22 12.5 19.8734 12.5 17.25C12.5 14.6266 14.6266 12.5 17.25 12.5C19.8734 12.5 22 14.6266 22 17.25ZM20 17.25C20 15.7312 18.7688 14.5 17.25 14.5C15.7312 14.5 14.5 15.7312 14.5 17.25C14.5 18.7688 15.7312 20 17.25 20C18.0059 20 18.6906 19.695 19.1876 19.2014L19.1967 19.1924C19.6931 18.6949 20 18.0083 20 17.25Z"}}]};

const PhoneSearchFilled = Vue.extend<IconProps>({
  name: 'PhoneSearchFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'phone-search-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PhoneSearchFilled;
